import React from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import LargeContainer from "../LargeContainer";
import MainContainer from "../MainContainer";

const BannerSection = () => {
  return (
    <LargeContainer style={{ marginTop: "2em" }}>
      <MainContainer>
        <BannerContainer>
          <BannerLarge bg="/grid_1.png">
            <SubHeading>Collection Of Cactus</SubHeading>
            <Heading>Pottery Pots & Plant</Heading>
            <Button to="/shop">SHOP Now</Button>
          </BannerLarge>
          <BannerSmall bg="/grid_2.png">
            <SubHeading> New Collection</SubHeading>
            <Heading>Plant Port</Heading>
            <Button to="/shop">SHOP Now</Button>
          </BannerSmall>
          <BannerSmall bg="/grid_3.png">
            <SubHeading>New Collection</SubHeading>
            <Heading>Plant Port</Heading>
            <Button to="/shop">SHOP Now</Button>
          </BannerSmall>
          <BannerLarge bg="/grid_4.png">
            <SubHeading>Collection Of Cactus</SubHeading>
            <Heading>Hanging Pots & Plant</Heading>
            <Button to="/shop">SHOP Now</Button>
          </BannerLarge>
        </BannerContainer>
      </MainContainer>
    </LargeContainer>
  );
};
const BannerLarge = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding: 2em 18em 2em 4em;
  background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.2)),
    url(${(props) => props.bg});
  background-size: cover;
  grid-column: span 2;
  /* overflow: hidden; */
  ::before {
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin-left: auto;
    margin-right: auto;
    margin-top: auto;
    margin-bottom: auto;
    content: "";
    position: absolute;
    width: 100%;
    height: 0%;

    background-color: #fff;
    opacity: 0.2;
  }
  ::after {
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin-left: auto;
    margin-right: auto;
    margin-top: auto;
    margin-bottom: auto;
    content: "";
    position: absolute;
    width: 0%;
    height: 100%;

    background-color: #fff;
    opacity: 0.2;
  }
  :hover {
    ::before {
      width: 100%;
      height: 100%;
      opacity: 0;
      transition: width 1s, height 1s, opacity 1s, display 1s;
    }
    ::after {
      width: 100%;
      height: 100%;
      opacity: 0;
      visibility: hidden;
      transition: width 1s, height 1s, opacity 1s, visibility 1s;
    }
  }
`;
const BannerSmall = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  flex-grow: 0;
  padding: 2em;
  background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.2)),
    url(${(props) => props.bg});
  background-size: cover;
  grid-column: span 1;
  overflow: hidden;

  ::before {
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin-left: auto;
    margin-right: auto;
    margin-top: auto;
    margin-bottom: auto;
    content: "";
    position: absolute;
    width: 100%;
    height: 0%;

    background-color: #fff;
    opacity: 0.2;
  }
  ::after {
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin-left: auto;
    margin-right: auto;
    margin-top: auto;
    margin-bottom: auto;
    content: "";
    position: absolute;
    width: 0%;
    height: 100%;
    z-index: 5000;

    background-color: #fff;
    opacity: 0.2;
  }
  :hover {
    ::before {
      width: 100%;
      height: 100%;
      opacity: 0;
      transition: width 1s, height 1s, opacity 1s;
    }
    ::after {
      width: 100%;
      height: 100%;
      opacity: 0;
      visibility: hidden;
      transition: width 1s, height 1s, opacity 1s, visibility 1s;
    }
  }
`;
const BannerContainer = styled.div`
  display: grid;
  overflow: hidden;
  grid-template-columns: 330px 330px 330px;
  grid-gap: 2em;
  grid-auto-rows: 300px;
  grid-auto-columns: 330px;
`;

const SubHeading = styled.div`
  font-size: 1.2em;
`;
const Heading = styled.div`
  font-size: 3rem;
`;
const Button = styled(NavLink)`
  text-decoration: none;
  flex-grow: 0;
  margin-top: 1em;
  padding: 1em 2em;
  background-color: #83aa4c;
  border-radius: 32px;
  color: white;
  cursor: pointer;
  scale: 1;
  transition: scale 0.5s;
  z-index: 6000;
  :hover {
    scale: 1.1;
  }
`;

export default BannerSection;
